export const PHOTOS_VIDEOS_INFO = {
  DEFAULT_START_PAGE: 1,
  PAGE_SIZE: 12
};
